<template>
  <div class="skeleton">
      <transition name="fade" v-if="visibleBoarding">
        <div class="music-onboarding">
          <div class="content">
            <p class="of font-bride">THE WEDDING OF</p>
            <img src="../assets/images/fatihah-fatnan/host.png" >
            <hr>
            <p>
              Kepada Yth.<br>
              Bapak/Ibu/Saudara/i
            </p>

            <p class="tamu">
              {{ you }}
            </p>

            <p>Tanpa mengurangi rasa hormat, kami mengundang Anda untuk hadir diacara pernikahan kami.</p>
            <button @click="toggleBoarding">Buka undangan</button>
          </div>
        </div>
      </transition>

      <div :class="['music-button', {'mute': !isPlaying}]" @click="play">
        <img src="../assets/images/della-juan/music.png" alt="">
      </div>

      <div :class="['content-wrapper', {'blur': visibleBoarding}]">
        <section class="header">
          <img src="../assets/images/fatihah-fatnan/decor1.png" >
          <img src="../assets/images/fatihah-fatnan/decor2.png" >
          <img src="../assets/images/fatihah-fatnan/decor3.png" >
        </section>

        <VueScrollFixedNavbar>
          <div class="sticky-nav">
            <div @click="scrollTo('profile')">Profil</div>
            <div @click="scrollTo('event')">Acara</div>
            <div @click="scrollTo('rsvp')">Konfirmasi</div>
            <div @click="scrollTo('gift')">Gifts</div>
            <div @click="scrollTo('gallery')">Galeri</div>
          </div>
        </VueScrollFixedNavbar>

        <section class="profile ">
          <p class="title">Bride and Groom</p>
          <div class="desktop-wrapper">
            <div class="profile-item animate__animated animate__fadeIn animate__slower">
              <div class="photo">
                <p class="photo-name">dr. Fatihah Nurul Fauziah</p>
                <img src="../assets/images/fatihah-fatnan/ulfah.jpg">
              </div>
              <div class="text">
                <p>
                  The day I met you was the best decision I've ever made, more days I spend with you, makes me find the best version of me, together with you is the best feeling I've ever had. grow old with you is my favorite bucketlist.
                </p>
              </div>
            </div>
            <div class="profile-item">
              <div class="photo">
                <p class="photo-name">Fatnan Ahmad Thawsan, S.T</p>
                <img src="../assets/images/fatihah-fatnan/fatnan.jpg">
              </div>
              <div class="text">
                <p>
                  The one who makes you who you are. The one who makes you feel comfortable all the time. The one who can make you realize that you deserve to be happy. It's you.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="timeline-story">
          <img src="../assets/images/fatihah-fatnan/decor3.png">
          <p class="title">Our Story</p>
          <div class="desktop-wrapper">
            <p>24 Desember 2019, menjadi awal dari sebuah kisah kami saat  Fatnan mulai menyapa Ulfah via instagram dan saling bertukar cerita. Kami memang satu almamater saat SMA, saling tau tapi tidak saling mengenal dan baru mengenal setelah sebuah sapaan.</p> 
            <br>
            <p>Seiring berjalannya waktu kami sering berbincang bercanda dan bertukar isi pikiran hingga menemukan kenyamanan dalam satu sama lain.
            Perbedaan profesi tidak menjadi sebuah penghalang untuk saling memahami, kami bertumbuh bersama sebagai seorang teman, sahabat dan partner. Setelah 3 tahun bersama saling berbagi rasa suka, duka, dan bahagia akhirnya kami menemukan titik temu, berhenti mencari dan insya Allah akan melangkah bersama menjadikan satu sama lain “rumah” sebagai tempat kembali ternyaman dan melengkapi dalam ikatan suci pernikahan.</p>
          </div>
          <img src="../assets/images/fatihah-fatnan/decor4.png">
          </section>

        <section class="event-detail">
          <div class="desktop-wrapper">
            <p>
              <i>Bismillaahirrahmaanirrahiim</i><br>
              <br>
              <i>Assalaamu'alaikum Warahmatullaahi Wabarakaatuh</i><br>
              <br>
              Maha Suci Allah yang telah menciptakan makhluk-Nya berpasang-pasangan.
              <br>
              Dengan mengharap ridho dan rahmat Allah Subhanahu wa Ta’ala untuk melaksanakan syari'at agama-Nya dan mengikuti sunnah Rasul-Nya dalam membentuk rumah tangga yang sakinah, mawaddah, warahmah.<br>
              <br>
              Tanpa mengurangi rasa hormat, kami mengundang Bapak/Ibu/Saudara/i untuk hadir dan memberikan do'a restu pada acara pernikahan kami:<br>
              <br>
              <br>
              <br>
              <span class="host">dr. Fatihah Nurul Fauziah</span><br>
              Putri dari Bapak H. Dedi Sobana dan<br>Ibu Hj. Lina Nurhasanah<br>
              <br>
              <span class="host">&amp;</span><br>
              <br>
              <span class="host">Fatnan Ahmad Thawsan, S.T.</span><br>
              Putra dari Bapak Sjafruddin Ahmad Hasan dan<br>Ibu Jeni Laelasari<br>
              <br>
              <br>
              <br>
              yang Insya Allah akan dilaksanakan pada:<br><br>
              <span class="dday">
                Sabtu, 8 Oktober 2022
              </span><br>
            </p>
            <div class="countdown">
              <countdown :time="weddingDate">
                <template slot-scope="props">
                  {{ props.days }} hari, {{ props.hours }} jam, {{ props.minutes }} menit lagi.
                </template>
              </countdown>
            </div>
            <div class="event">
              <img src="../assets/images/fatihah-fatnan/decor4.png">
              <img src="../assets/images/fatihah-fatnan/decor5.png">
              <div class="detail">
                <p class="title">Akad Nikah</p>
                <p class="event-time">Pukul <b>08.00 s.d. 10.00 WIB</b></p>
                <br>
                <p class="title">Resepsi</p>
                <p class="event-time">Pukul <b>11.00 s.d 14.00 WIB</b></p>
                <br>
                <p class="event-venue">
                  di <b>Pavillion Function Point</b><br>
                  Jl. Dr. Djunjunan No.102-112,<br>
                  Pasteur, Bandung
                </p>
                <a href="https://www.google.com/maps/dir//Pavilion+Function+Point,+40173,+Jl.+Dr.+Djunjunan+No.102-112,+Sukagalih,+Sukajadi,+Bandung+City,+West+Java+40162/@-6.8958127,107.5900252,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x2e68e665b12431c5:0xaad5ab96232f9993!2m2!1d107.5900252!2d-6.8958127!3e0" target="_blank" class="button"><b>Lihat di peta</b></a>
              </div>
            </div>

            <p>
              Acara ini diselenggarakan dengan tetap menjalankan protokol kesehatan yang harus dipatuhi demi mencegah penyebaran virus Covid-19. Tanpa mengurangi rasa hormat, para tamu undangan dihimbau untuk tetap melakukan 3M:
            </p>
            <div class="aturan-3m">
              <div>
                <img src="../assets/images/dina-resha/mask.png" alt="Memakai masker" width="60">
                <p>Memakai masker</p>
              </div>
              <div>
                <img src="../assets/images/dina-resha/distancing.png" alt="Menjaga jarak" width="60">
                <p>Menjaga jarak</p>
              </div>
              <div>
                <img src="../assets/images/dina-resha/washing hands.png" alt="Mencuci tangan" width="60">
                <p>Mencuci tangan</p>
              </div>
            </div>
            <br>
            <br>

            <p>
              Merupakan suatu kerhormatan dan kebahagiaan bagi kami apabila Bapak / Ibu / Saudara/i, berkenan hadir untuk memberikan doa restu pada acara pernikahan kami.
              <br>
              <br>
              <i>Wassalamu'alaikum Warahmatullahi Wabarakatuh</i>
              <br>
              <br>
              Kami yang berbahagia,
              <br>
              <br>
            </p>
            <div class="family">
              <div class="parent">
                <p>Keluarga</p>
                <p>
                  <span>H. Dedi Sobana</span><br>
                  <span>Hj. Lina Nurhasanah</span>
                </p>
              </div>
              <div class="parent">
                <p>Keluarga</p>
                <p>
                  <span>Sjafruddin Ahmad Hasan</span><br>
                  <span>Jeni Laelasari</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="form-greetings ">
          <img src="../assets/images/fatihah-fatnan/decor1.png" >
          <img src="../assets/images/fatihah-fatnan/decor2.png" >
          <p class="title">Konfirmasi kehadiran</p>
          <div class="desktop-wrapper">
            <form action="https://docs.google.com/forms/u/3/d/e/1FAIpQLScJXbBfGf-L_2v088LbKRQ-hr7ca7K062drzcHgJt5e51F7aA/formResponse" name="ulfahFatnanRsvp">
              <div class="form-input">
                <input type="text" v-model="name" maxlength="30" name="entry.2009325773">
                <span>Nama</span>
              </div>
              <div class="form-input">
                <select name="entry.1526040848" id="jumlah" v-model="jumlah">
                  <option value="1">1 orang</option>
                  <option value="2">2 orang</option>
                </select>
                <span>Jumlah yang akan hadir</span>
              </div>
              <div class="form-input">
                <select name="entry.726002395" id="konfirmasi" v-model="konfirmasi">
                  <option value="yes">Iya, saya akan datang</option>
                  <option value="no">Maaf, saya tidak bisa datang</option>
                </select>
                <span>Konfirmasi</span>
              </div>
              <div class="form-input">
                <textarea name="greeting" id="" cols="30" maxlength="250" rows="5" v-model="greeting"></textarea>
                <span>Ucapan dan do'a</span>
              </div>
              <!-- <input type="submit" value="Submit"> -->
            </form>
            <p v-if="!formFilled"><i>{{ error }}</i></p>
            <a @click="submitForm">Kirim</a>
          </div>
          <p class="hashtag">#wonderfULFATe</p>
        </section>

        <section class="greetings " v-if="!!formData">
          <p class="title">Ucapan &amp; do'a</p>
          <div class="desktop-wrapper">
            <carousel :per-page="1" :autoplay="true" :loop="true"
              :paginationEnabled="false" :navigationEnabled="true" :speed="1000"
              :navigationNextLabel="'>'" :navigationPrevLabel="'<'"
            >
              <slide v-for="(data, index) in formData" :key="index">
                <p>{{ data.greeting}}</p>
                <br>
                <p><b>{{ data.name }}</b></p>
              </slide>
            </carousel>
          </div>
        </section>

        <section class="gifts">
          <p class="title">Wedding Gifts</p>
          <div class="desktop-wrapper">
            <p>Apabila ingin mengirimkan Wedding Gifts untuk kami, bisa melalui QRIS berikut ini:</p>
            <div class="gift-details">
              <img src="../assets/images/fatihah-fatnan/qris.png">
              <p>atau, untuk alamat pengiriman gifts:</p>
              <p>Jl. Warungpulus RT 01/009,<br> Batujajar, Bandung Barat</p>
            </div>
          </div>
        </section>

        <section class="gallery ">
          <div class="desktop-wrapper">
            <p class="title">Gallery</p>

            <carousel :per-page="1" :autoplay="true" :loop="true"
              :paginationEnabled="false" :navigationEnabled="false" :speed="1000"
              :adjustableHeight="false" :centerMode="true"
            >
              <slide><img src="../assets/images/fatihah-fatnan/1.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/2.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/3.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/4.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/5.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/6.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/7.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/8.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/9.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/10.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/11.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/12.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/13.jpg"></slide>
              <slide><img src="../assets/images/fatihah-fatnan/14.jpg"></slide>
            </carousel>
          </div>
        </section>

        

        <footer class="">
          <p>made with love by <b><a href="http://invity.id/contact" target="_blank">invity.id</a></b> &copy; 2022</p>
        </footer>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'
import 'animate.css'
import {VueScrollFixedNavbar} from "vue-scroll-fixed-navbar";

  export default {
    name: 'FatihahFatnan',
    data () {
      return {
        visibleBoarding: true,
        isPlaying: false,
        audio : new Audio(require('../assets/sounds/edsheeran.mp3')),
        formData: {},
        name: '',
        greeting:'',
        error: '',
        konfirmasi: 'yes',
        jumlah: '1',
        messageWhenNoItems: 'There arent items'
      }
    },
    components: {
      Carousel,
      Slide,
      VueScrollFixedNavbar
    },
    created(){
      document.querySelector('body').style.overflowY = 'hidden'
      this.getFormData()
      this.name = this.$route.query.to || ''
    },
    computed: {
      you () {
        return this.$route.query.to || 'You'
      },
      weddingDate(){
        return moment("2022-10-08T08:00:00").diff(moment(),'milliseconds');
      },
      shift () {
        const jam = this.$route.query.jam || 0
        switch (jam) {
          case '11': return '11.00 - 12.30'
          case '12': return '12.30 - 14.00'
          default: return '11.00 - 14.00'
        }
      },
      formFilled () {
        return this.name.length > 3 
          && this.greeting.length > 5
          && !!this.konfirmasi
          && !!this.jumlah
      }
    },
    methods: {
      toggleBoarding () {
        this.visibleBoarding = !this.visibleBoarding
        document.querySelector('body').style.overflowY = ''
        this.play()
      },
      play() {
        if(!this.isPlaying){
          this.audio.loop = true;
          this.audio.play();
          this.isPlaying = true;
        } else {
          this.audio.pause()
          this.isPlaying = false;
        }
      },
      submitForm(){
        const result = this.constructData(this.name, this.greeting);    
        const api = 'https://landing-page-ad31d.firebaseio.com/fatihahFatnan.json'

        if (this.formFilled) {
          axios.post(api, result)
          .then(this.successCallback()).catch(function (error) {
            // eslint-disable-next-line no-console
            console.log(error)
          })
          document.ulfahFatnanRsvp.submit()
          // reset form
          this.error = ''
          this.name = ''
          this.greeting = ''
        } else {
          this.error = `Pastikan semua form sudah terisi ya`
        }
      },
      getFormData(){
        const api = 'https://landing-page-ad31d.firebaseio.com/fatihahFatnan.json';
        axios.get(api).then((response) => {
            this.formData = response.data;
        })
      },
      constructData(name, greeting){
        const currentData = {
            name: name,
            greeting: greeting
        };
        return currentData;
      },
      successCallback(){
        this.$toasted.show("Ucapan dan do'a berhasil di kirim :)").goAway(3000)
        setTimeout(() => { this.getFormData() }, 300)
      },
      scrollTo (section) {
        const sections = {
          profile: 'section.profile',
          event: 'span.dday',
          rsvp: 'section.form-greetings',
          gift: 'section.gifts',
          gallery: 'section.gallery'
        }
        const target = document.querySelector( sections[section] )
        target.scrollIntoView( { behavior: 'smooth', block: 'start' } )
      }
    }
  }
</script>

<style lang="scss" scoped>

  // FONTS
  @import url('https://fonts.googleapis.com/css2?family=Philosopher&display=swap');
  @font-face {
    font-family: 'title';
    src: url('../fonts/heading-webfont.woff2') format('woff2'),
          url('../fonts/heading-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }


  // COLORS
  $coksu: #a5837e;
  $cream: #89796c;
  $navy: #484d5a;
  $cokfont: #484d5a;
  $ivory: #ebebd8;


  // GENERAL STYLING
  p {
    font-family: 'Pontano Sans', sans-serif;
    font-size: .85rem;
    line-height: 1.5;
    letter-spacing: .04rem;
    color: $cokfont;
    margin: 0;
  }

  .skeleton {
    background: #fffeec;
    transition: all .3s ease-in-out;
  }
  .desktop-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    @media only screen and (max-width: 768px) {
      width: calc(100% - 64px);
      padding: 0 32px;
    }
  }


  // SECTION STYLING
  .header {
    width: 100%;
    height: 100vh;
    background-image: url('../assets/images/fatihah-fatnan/header.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    background-position: center;
    img:nth-of-type(1) {
      width: 200px;
      position: absolute;
      bottom: -64px;
      left: -110px;
    }
    img:nth-of-type(2) {
      width: 200px;
      position: absolute;
      top: -64px;
      right: -90px;
    }
    img:nth-of-type(3) {
      width: 300px;
      position: absolute;
      top: -44px;
      left: -59px;
    }
  }

  .event-detail {
    margin: 80px 0;
    .host {
      font-family: 'Philosopher', serif;
      font-size: 1.5rem;
      @media only screen and (max-width: 768px) {
        font-size: 1.4rem;
        line-height: 2;
        font-weight: 700;
      }
    }
    .dday {
      font-family: 'Philosopher', serif;
      font-size: 2rem;
      font-weight: 700;
      @media only screen and (max-width: 768px) {
        font-size: 1.5rem;
      }
    }

    .title {
      font-family: 'Philosopher', serif;
      font-size: 1.2rem;
      font-weight: 700;
    }

    .countdown {
      font-family: 'Pontano Sans', sans-serif;
      font-size: .85rem;
      line-height: 1.5;
      letter-spacing: .04rem;
      color: $cokfont;
      margin: 0;
    }

    .button {
      margin: 12px auto 0;
      font-size: .8rem;
      border: none;
      border-radius: 100px;
      font-family: inherit;
      padding: 12px;
      cursor: pointer;
      background: #e1ac9e;
      color: white;
      text-decoration: none;
      display: block;
      width: 100px;
      font-family: 'Pontano Sans', sans-serif;
    }
    .event {
      border: solid 1px;
      border-color: #eedbcd;
      padding: 50px 0 20px;
      margin: 40px 0;
      border-top-right-radius: 50%;
      border-top-left-radius: 50%;
      background: #eedbcd;
      position: relative;
      @media only screen and (max-width: 768px) {
        display: block;
        .detail + .detail {
          margin-top: 40px;
        }
      }
      &-name {
        font-family: 'Philosopher', serif;
        font-size: 1.5rem;
        @media only screen and (max-width: 768px) {
          font-size: 1.3rem;
        }
      }
      &-time {
        margin: 8px 0;
      }
      &-venue {
        line-height: 1.5;
      }
      img:nth-of-type(1) {
        position: absolute;
        left: -150px;
        top: -135px;
        width: 200px;
      }
      img:nth-of-type(2) {
        position: absolute;
        right: -150px;
        top: -135px;
        width: 200px;
      }
    }
    .family {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .parent {
        display: block;
        p {
          &:nth-of-type(1) {
            margin-right: 8px;
          }
          span:nth-of-type(2) {
            &:before {
              content: '';
              width: 100%;
              height: 1px;
              background: $cokfont;
              display: block;
            }
          }
        }
        @media only screen and (max-width: 400px) {
          p {
            font-size: .7rem;
          }
        }
      }
    }
  }

  .timeline-story {
    padding: 30px 0;
    position: relative;
    p {
      text-align: justify;
    }
    p.title {
      font-family: 'title';
      font-size: 2.4rem;
      margin-bottom: 20px;
      text-align: center;
    }
    img:nth-of-type(1) {
      position: absolute;
      top: -50px;
      left: -100px;
      width: 286px;
    }
    img:nth-of-type(2) {
      position: absolute;
      bottom: -55px;
      right: -70px;
      width: 226px;
    }
  }

  .profile {
    position: relative;
    padding: 80px 0;
    p.title {
      font-family: 'title';
      font-size: 2.4rem;
      margin-bottom: 20px;
      text-align: center;
    }
    &-item {
      display: flex;
      z-index: 1;
      position: relative;
      & + .profile-item {
        margin-top: 60px;
      }
      &:nth-child(2) {
        direction: rtl;
        .photo-title {
          right: auto;
          left: 10px;
        }
        .photo-name {
          left: auto;
          right: -10px;
          bottom: -14px;
        }
        .text {
          direction: ltr;
          padding: 0 16px 37px 0;
          text-align: right;
        }
      }
      .photo {
        width: 200px;
        position: relative;
        
        @media only screen and (max-width: 480px) {
          margin: 0 auto;
        }
        img {
          width: 100%;
          border-radius: 20px;
          position: absolute;
          bottom: 15px;
          left: 0;
          z-index: -1;
          @media only screen and (min-width: 768px) {
            position: relative;
          }
        }
        &-title {
          font-family: 'title';
          font-size: 1.6rem;
          position: absolute;
          top: -20px;
          right: 10px;
        }
        &-name {
          font-family: 'Philosopher', serif;
          font-size: 1.2rem;
          position: absolute;
          background: $navy;
          color: ivory;
          border-radius: 100px;
          padding: 6px 16px;
          width: max-content;
          bottom: -14px;
          left: -16px;
        }
      }
      .text {
        width: calc(100% - 200px);
        padding-left: 16px;
        text-align: left;
        @media only screen and (max-width: 480px) {
          width: calc(100% - 64px);
          padding: 0 0px 37px 16px;
        }
        p {
          line-height: 1.5;
        }
        a {
          font-family: 'Pontano Sans', sans-serif;
          color: $cokfont;
          text-decoration: none;
          display: flex;
          font-size: .9rem;
          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .gallery {
    padding-top: 80px;
    p.title {
      font-family: 'title';
      font-size: 2.4rem;
      margin-bottom: 20px;
      text-align: center;
    }
    img {
      width: 99%;
      border-radius: 16px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    ::v-deep .VueCarousel-navigation-button {
      background: $coksu;
      color: $ivory;
      border-radius: 100px;
      width: 30px;
      height: 30px;
      padding: 5px !important;
      font-weight: 600;
    }
  }

  footer {
    padding: 30px 0 10px;
    a {
      font-family: 'Pontano Sans', sans-serif;
      color: $coksu;
      text-decoration: none;
    }
  }

  .music-onboarding {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    box-sizing: border-box;
    font-family: 'Pontano Sans', sans-serif;
    font-size: .85rem;
    line-height: 1.5;
    letter-spacing: .04rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      background: #fffeec;
      padding: 20px;
      border-radius: 20px;
      box-sizing: content-box;
      width: 100%;
      margin: 20px;
      max-width: 280px;
      width: 100%;
      box-shadow:
        0 2.8px 2.2px rgba(0, 0, 0, 0.034),
        0 6.7px 5.3px rgba(0, 0, 0, 0.048),
        0 12.5px 10px rgba(0, 0, 0, 0.06),
        0 22.3px 17.9px rgba(0, 0, 0, 0.072),
        0 41.8px 33.4px rgba(0, 0, 0, 0.086),
        0 100px 80px rgba(0, 0, 0, 0.12);
      z-index: 1;
      .font-bride {
        font-size: 1rem;
        font-family: 'Philosopher', serif;
        color: #b06756;
      }
      hr {
        background-color: #b06756;
        border-style: none;
        height: 1px;
        opacity: .3;
        margin: 0 0 20px;
      }
      img {
        width: 200px;
        padding: 16px 0;
      }
    }
    &:before {
      content: '';
      background:  #ededed;
      position: absolute;
      left: 0;
      top: 0;
      opacity: .7;
      width: 100%;
      height: 100%;
    }
    p {
      z-index: 1;
      position: relative;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      cursor: pointer;
      outline: none;
      &.tamu {
        font-size: 1.5rem;
        margin: 20px 0;
        color: #b06756;
      }
    }
    button {
      z-index: 1;
      position: relative;
      border: none;
      padding: 16px 24px;
      border-radius: 20px;
      margin-top: 20px;
      background: #b06756;
      color: white;
    }
  }

  .content-wrapper {
    padding-bottom: 80px;
    background: #fffeec;
    color: #000;
    scroll-behavior: smooth;
    overflow-x: hidden;
    &.blur {
      filter: blur(4px);
    }
    @media only screen and (min-width: 768px) {
      width: 665px;
      margin: auto;
    }
  }

  .music-button {
    position: fixed;
    right: 0;
    top: 60%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    background: #d9d8c6;
    border-radius: 100%;
    z-index: 4;
    cursor: pointer;
    opacity: .8;
    img {
      width: 20px;
      position: relative;
      top: 10px;
      left: -2px;
    }
    &.mute {
      &:before {
        content: "";
        width: 30px;
        height: 2px;
        background: $coksu;
        position: absolute;
        transform: rotate(-45deg);
        bottom: 17px;
        right: 4px;
        z-index: 1;
        border: 1px solid #d9d8c6;
        opacity: .7;
      }
    }
    @media only screen and (max-width: 768px) {
      right: -16px;
    }
  }

  .greetings {
    padding: 32px 20px;
    .title {
      font-family: 'title';
      font-size: 2.4rem;
      margin-bottom: 20px;
    }
    ::v-deep .VueCarousel {
      border: 1px solid #b06756;
      padding: 20px 0;
      border-radius: 16px;
    }
    ::v-deep .VueCarousel-navigation-button {
      background: $coksu;
      color: $ivory;
      border-radius: 100px;
      width: 30px;
      height: 30px;
      padding: 5px !important;
      font-weight: 600;
    }
  }

  .form-greetings {
    padding: 24px 0 40px;
    position: relative;
    .title {
      font-family: 'title';
      font-size: 2rem;
      margin-bottom: 20px;
    }
    img:nth-of-type(1) {
      position: absolute;
      width: 177px;
      left: -90px;
      top: 0;
    }
    img:nth-of-type(2) {
      position: absolute;
      width: 177px;
      right: -90px;
      bottom: 0;
    }
    .form-input {
      position: relative;
      margin-top: 24px;
      span {
        position: absolute;
        top: 4px;
        left: 49px;
        font-family: 'Pontano Sans', sans-serif;
        font-size: .7rem;
        letter-spacing: .04rem;
      }
    }
    input, select {
      width: calc(100% - 64px);
      height: 40px;
      padding: 16px 16px 9px;
      box-sizing: border-box;
      background: transparent;
      border: 1px solid #b06756;
      border-radius: 16px;
      color: #b06756;
      &:focus, &:active {
        outline: none;
      }
    }
    select {
      height: 52px;
    }
    textarea {
      font-family: 'Pontano Sans', sans-serif;
      font-size: .85rem;
      line-height: 1.5;
      letter-spacing: .04rem;
      width: calc(100% - 64px);
      margin: 0 32px;
      padding: 16px;
      box-sizing: border-box;
      background: transparent;
      border: 1px solid #b06756;
      border-radius: 16px;
      color: #b06756;
      &:focus, &:active {
        outline: none;
      }
    }
    a {
      margin: 12px auto 0;
      font-size: .8rem;
      border: none;
      border-radius: 100px;
      font-family: inherit;
      padding: 12px;
      cursor: pointer;
      background: #b06756;
      color: $ivory;
      text-decoration: none;
      display: block;
      width: 150px;
      font-family: 'Pontano Sans', sans-serif;
    }
    .hashtag {
      font-family: "Philosopher", sans-serif;
      font-size: 1.5rem;
      padding: 20px 0;
    }
  }

  .aturan-3m {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    img {
      filter: brightness(0.6);
    }
  }

  .sticky-nav {
    background: #ee9c86;
    border-radius: 40px;
    padding: 20px;
    position: fixed;
    bottom: 8px;
    width: calc(100% - 16px);
    box-sizing: border-box;
    z-index: 3;
    margin: 0 8px;
    left: 0;
    font-family: 'Pontano Sans', sans-serif;
    font-size: .85rem;
    justify-content: space-between;
    display: flex;
    color: white;
    @media only screen and (min-width: 768px) {
      width: 665px;
      margin: auto;
      left: 50%;
      transform: translate(-50%,0);
    }
  }

  .gifts {
    margin: 80px 0 0;
    p.title {
      font-family: 'title';
      font-size: 2.4rem;
      margin-bottom: 40px;
      text-align: center;
    }
    button {
      margin: 24px auto 0;
      font-size: .8rem;
      border: none;
      border-radius: 100px;
      font-family: inherit;
      padding: 12px;
      cursor: pointer;
      background: #e1ac9e;
      color: white;
      text-decoration: none;
      display: inline-block;
      width: 100px;
      font-family: 'Pontano Sans', sans-serif;
    }
    .gift-details {
      margin-top: 24px;
      margin-top: 24px;
      img {
        width: 280px;
        border-radius: 16px;
        padding: 20px 0;
      }
    }
  }
</style>
